import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import {
	Button,
	CreateButton,
	ExportButton,
	TopToolbar,
	sanitizeListRestProps,
	useListContext,
	usePermissions,
	useTranslate,
} from "react-admin";

import { UploadButton } from "../../../components/dialogs/ArticlePreviewButton";
import ImportPreviewButton from "../../../components/dialogs/OrderImportPreview";
import {
	OrdersExportModal,
	OrdersExportWithFilters,
} from "../../../components/dialogs/OrdersExportDialog/";
import { hasAccessToExport, hasAccessToImport } from "../../../entities";

export const OrdersActions = (props) => {
	const { className, exporter, filters, isDraft, ...rest } = props;
	const {
		currentSort,
		resource,
		displayedFilters,
		filterValues,
		hasCreate,
		basePath,
		selectedIds,
		showFilter,
		total,
	} = useListContext(props);
	const { permissions } = usePermissions();
	const isAccessToExport = hasAccessToExport(permissions);
	const isAccessToImport = hasAccessToImport(permissions);

	return React.useMemo(
		() => (
			<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
				{filters &&
					React.cloneElement(filters, {
						resource,
						showFilter,
						displayedFilters,
						filterValues,
						context: "button",
					})}
				{/* {(exporter !== false && isAccessToExport) && (
                    <ExportButton
                        disabled={total === 0}
                        resource={resource}
                        sort={currentSort}
                        filterValues={filterValues}
                    />
                )} */}
				{/* {isAccessToExport && (<OrdersExportModal title="Export" filters={filterValues}/>)}
                {isAccessToExport && (<OrdersExportModal title="Export Search" />)} */}
				{isAccessToImport && (
					<ImportPreviewButton company_id={permissions.company_id} role={permissions.role} />
				)}
				{!isDraft && isAccessToExport && <OrdersExportWithFilters filters={filterValues} />}
				{!isDraft && isAccessToExport && <OrdersExportModal userId={permissions.id} />}
				{hasCreate && <CreateButton basePath={basePath} />}
			</TopToolbar>
		),
		[resource, displayedFilters, filterValues, selectedIds, filters, total] // eslint-disable-line react-hooks/exhaustive-deps
	);
};
